import React, { useState } from 'react';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for your inquiry. We will contact you within 24 hours.');
    setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
  };

  return (
    <div className="page-content">
      <div className="page-header">
        <h1>Contact Us</h1>
        <p>Schedule your free consultation today</p>
      </div>

      <section className="content-section">
        <div className="contact-container">
          <div>
            <h2 style={{ marginBottom: '30px', color: '#1a365d' }}>Send Us a Message</h2>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Full Name *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Email Address *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Phone Number</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Subject *</label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Message *</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>
              <button type="submit" className="cta-button">Submit Inquiry</button>
            </form>
          </div>

          <div className="contact-info">
            <h3>Get In Touch</h3>
            <p><strong>Address:</strong><br />
            Sol LLP<br />
            2314 Ellis Street, Suite 300<br />
            Kelowna, BC V1Y 1Z4</p>

            <p><strong>Phone:</strong> (250) 862-1234<br />
            <strong>Fax:</strong> (250) 862-1235<br />
            <strong>Email:</strong> info@sollawpartners.com</p>

            <p><strong>Office Hours:</strong><br />
            Monday - Friday: 8:30 AM - 5:00 PM<br />
            Saturday: By Appointment Only<br />
            Sunday: Closed</p>

            <p style={{ marginTop: '30px', padding: '20px', background: 'white', borderRadius: '5px' }}>
              <strong>Emergency Consultations Available</strong><br />
              For urgent legal matters, please call our office and our team will arrange a prompt consultation.
            </p>

            <p style={{ marginTop: '20px' }}>
              <strong>Parking & Accessibility:</strong><br />
              Free parking available in the building parkade. Our office is wheelchair accessible with elevator access to Suite 300.
            </p>
          </div>
        </div>

        <div style={{ marginTop: '60px', padding: '40px', background: 'white', borderRadius: '8px' }}>
          <h3 style={{ marginBottom: '20px', color: '#1a365d' }}>What to Expect</h3>
          <div className="text-content">
            <p><strong>1. Initial Contact:</strong> Reach out via phone, email, or this contact form. We respond to all inquiries within one business day.</p>
            
            <p><strong>2. Free Consultation:</strong> We offer complimentary initial consultations for most matters. During this meeting, we'll discuss your situation, explain your legal options, and provide honest advice about the best path forward.</p>
            
            <p><strong>3. Transparent Fees:</strong> If you choose to retain our services, we'll provide a clear explanation of our fee structure. Personal injury cases are handled on a contingency basis (no win, no fee), while family law matters typically involve hourly billing or flat fees depending on the service.</p>
            
            <p><strong>4. Confidentiality:</strong> Everything you share with us is protected by solicitor-client privilege. Your privacy and trust are paramount.</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;

